import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { useQueryClient } from 'react-query';
import checkAppDestination from 'components/checkAppDestination';

const customTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiPaper: {
      root: {
        background: 'none !important',
      },
    },
    MuiDialogContent: {
      root: {
        overflowY: 'unset',
      },
    },
    MuiDialog: {
      paper: {
        overflowY: 'unset',
      },
    },
  },
});

function Campaign({popups}) {
  const history = useHistory();
  const [open, setopen] = useState(true);

  const handleCloseLogin = () => {
    typeof window !== 'undefined' && localStorage.setItem('popupOpen', false);
    setopen(false);
  };

  const handleClick = (app_destination) => {
    typeof window !== 'undefined' && localStorage.setItem('popupOpen', false);
    const url = checkAppDestination(app_destination);

    history.push({ pathname: url });
  };

  const displayImage = (targetCampaigns) => {
    let index = Math.floor(Math.random() * targetCampaigns.length);
    return !targetCampaigns.length ? null : (
      <MuiThemeProvider theme={customTheme}>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={styles.dialog}
        >
          <div>
            <DialogContent className={styles.dialogContent}>
              <IconButton onClick={handleCloseLogin} className={styles.iconButton}>
                <ClearIcon className={styles.clearIcon} />
              </IconButton>
              <div style={{ cursor: 'pointer' }} onClick={() => handleClick(targetCampaigns[0].app_destination)}>
                <img style={{ width: '100%' }} src={targetCampaigns[index].url} alt="" />
              </div>
            </DialogContent>
          </div>
        </Dialog>
      </MuiThemeProvider>
    );
  };

  return <div className={styles.popup}>{displayImage(popups)}</div>;
}
export default Campaign;
